/* necalli — inner templates behaviour.
   1. Slug ids on every heading inside rendered prose, so footer/nav links
      can anchor straight to a section (e.g. /pages/faq#orders-and-shipping).
   2. A table of contents built from the h1/h2 headings, shown only when
      there are at least three of them (FAQ, Terms, Privacy).
   3. Current-section highlight in that table of contents. */
(function () {
  'use strict';

  var MIN_HEADINGS = 3;

  function slugify(text) {
    var s = String(text || '').trim();
    if (s.normalize) s = s.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return s
      .toLowerCase()
      .replace(/['\u2018\u2019]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 72)
      .replace(/-+$/g, '');
  }

  function initProse(prose) {
    if (prose.__ncProse) return;
    prose.__ncProse = true;

    var headings = prose.querySelectorAll('h1, h2, h3, h4, h5, h6');
    var used = {};
    var i;
    for (i = 0; i < headings.length; i++) {
      var h = headings[i];
      var id = h.getAttribute('id');
      if (!id) {
        id = slugify(h.textContent || '') || 'section';
        if (used[id] || document.getElementById(id)) {
          var n = 2;
          while (used[id + '-' + n] || document.getElementById(id + '-' + n)) n++;
          id = id + '-' + n;
        }
        h.setAttribute('id', id);
      }
      used[id] = true;
    }

    var toc = document.querySelector('[data-nc-toc]');
    if (!toc) return;

    var tops = [];
    for (i = 0; i < headings.length; i++) {
      var tag = headings[i].tagName;
      if (tag === 'H1' || tag === 'H2') tops.push(headings[i]);
    }
    if (tops.length < MIN_HEADINGS) return;

    var list = toc.querySelector('[data-nc-toc-list]');
    if (!list || toc.__ncToc) return;
    toc.__ncToc = true;
    var frag = document.createDocumentFragment();
    var links = [];
    for (i = 0; i < tops.length; i++) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + tops[i].id;
      a.textContent = (tops[i].textContent || '').trim();
      a.setAttribute('data-level', tops[i].tagName === 'H1' ? '1' : '2');
      li.appendChild(a);
      frag.appendChild(li);
      links.push(a);
    }
    list.appendChild(frag);
    toc.removeAttribute('hidden');
    var doc = toc.closest ? toc.closest('.nc-doc') : null;
    if (doc) doc.classList.add('has-toc');

    if (!('IntersectionObserver' in window)) return;
    var visible = [];
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var idx = visible.indexOf(e.target);
        if (e.isIntersecting && idx === -1) visible.push(e.target);
        if (!e.isIntersecting && idx > -1) visible.splice(idx, 1);
      });
      var current = null;
      for (var j = 0; j < tops.length; j++) {
        if (visible.indexOf(tops[j]) > -1) { current = tops[j]; break; }
      }
      for (var k = 0; k < links.length; k++) {
        if (current && links[k].getAttribute('href') === '#' + current.id) links[k].setAttribute('aria-current', 'true');
        else links[k].removeAttribute('aria-current');
      }
    }, { rootMargin: '-120px 0px -62% 0px', threshold: 0 });
    for (i = 0; i < tops.length; i++) io.observe(tops[i]);
  }

  function init(root) {
    root = root || document;
    var nodes = root.querySelectorAll('[data-nc-prose]');
    for (var i = 0; i < nodes.length; i++) initProse(nodes[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
